module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.certificationProcess.status <= 6) ? _c('md-layout', {
    key: "syncInformations",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SINCRONIZAR INFORMAÇÕES TEMPORARIAMENTE")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Este processo visa sincronizar as informações coletadas até o momento e liberar espaço para coletar mais.")]), _vm._v(" "), (_vm.syncStarted) ? _c('md-list', _vm._l((_vm.certificationProcess.areas), function(area) {
    return _c('area-sync-list', {
      key: area.id,
      attrs: {
        "area": area
      },
      on: {
        "areaSynced": _vm.handleAreaSync
      }
    })
  }), 1) : _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startSync
    }
  }, [_vm._v("Iniciar a Sincronização")])], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SUCESSO!\n      "), _c('b', [_vm._v(_vm._s(_vm.blh.name))])]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("DADOS TEMPORARIOS SINCRONIZADO COM SUCESSO!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Agora você pode continuar com a captura de informações")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet, não é possível sincronizar.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.createSyncWorkers()
      }
    }
  }, [_vm._v("Reiniciar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e7971bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SyncView.vue
// module id = 838
// module chunks = 1